<template>
  <div>
    <v-sheet elevation="3" class="mt-3 mx-2">
      <div>
        <!-- <small>{{ this.slates }}</small> -->
        <v-data-table
          :headers="headers"
          :items="playerDetails.data"
          :item-key="playerDetails._id"
          class="elevation-1"
          height="850"
          :footerProps="footerProps"
        >
          <!-- profile image -->
          <template v-slot:item.PhotoUrl="{ item }">
            <v-avatar width="37" height="48">
              <img :src="item.PhotoUrl" />
            </v-avatar>
          </template>
          <!-- profile image ends -->

          <!-- player name -->
          <template v-slot:item.Name="{ item }">
            <!-- <router-link
              :to="{
                name: 'PlayerDetail',
                params: { playerId: item.PlayerID,SportId: item.SportId },
              }"
              style="text-decoration: none;"
              class="caption"
            >
              {{ item.Name }}
            </router-link> -->
            <p class="caption green--text">{{ item.Name }}</p>
            <!-- status -->
            <v-row justify="center">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-col
                    cols="2"
                    md="3"
                    sm="1"
                    v-show="item.InjuryStatus == null"
                    v-on="on"
                    v-bind="attrs"
                  >
                    <status-indicator status="positive" pulse />
                  </v-col>
                </template>
                <span>Healthy</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-col
                    cols="2"
                    md="3"
                    sm="1"
                    v-show="item.InjuryStatus == 'Out'"
                    v-on="on"
                    v-bind="attrs"
                  >
                    <status-indicator status="negative" pulse />
                  </v-col>
                </template>
                <span>Out</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-col
                    cols="2"
                    md="3"
                    sm="1"
                    v-on="on"
                    v-bind="attrs"
                    v-show="item.InjuryStatus == 'Questionable'"
                  >
                    <status-indicator status="intermediary" pulse />
                  </v-col>
                </template>
                <span>Questionable</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-col
                    cols="2"
                    md="3"
                    sm="1"
                    v-on="on"
                    v-bind="attrs"
                    v-show="
                      item.InjuryStatus == 'Probable' ||
                      item.InjuryStatus == 'Doubtful'
                    "
                  >
                    <status-indicator status="active" pulse />
                  </v-col>
                </template>
                <span>Probable</span>
              </v-tooltip>
            </v-row>
          </template>
          <!-- status ends-->
          <!-- player name ends -->

          <!-- position -->
          <template v-slot:item.DraftKingsPosition="{ item }">
            <p class="caption" v-if="slates[0].Operator == 'DraftKings'">
              {{ item.DraftKingsPosition }}
              <small class="caption" v-if="item.DepthChartOrder == '0'">
                1
              </small>
              <small class="caption" v-else-if="item.DepthChartOrder == '1'">
                2
              </small>
              <small class="caption" v-else-if="item.DepthChartOrder == '2'">
                3
              </small>
              <small v-else>3</small>
            </p>
            <p v-else class="caption">
              {{ item.FanDuelPosition }}
              <small class="caption" v-if="item.DepthChartOrder == '0'">
                1
              </small>
              <small class="caption" v-else-if="item.DepthChartOrder == '1'">
                2
              </small>
              <small class="caption" v-else-if="item.DepthChartOrder == '2'">
                3
              </small>
              <small v-else>3</small>
            </p>
          </template>
          <!-- position ends -->

          <!-- salary -->
          <template v-slot:item.DraftKingsSalary="{ item }">
            <p
              v-if="slates[0].Operator == 'DraftKings'"
              class="caption green--text"
            >
              {{ item.DraftKingsSalary }}
            </p>
            <p v-else class="caption green--text">{{ item.FanDuelSalary }}</p>
          </template>
          <!-- salary ends -->

          <!-- matchup -->
          <template v-slot:item.Opponent="{ item }">
            <p
              class="caption"
              :style="[
                item.HomeOrAway == 'AWAY'
                  ? { color: 'black' }
                  : { color: 'black' },
              ]"
            >
              {{ item.Team }}&nbsp;
              <small class="black--text">@ </small>
              <span
                :style="[
                  item.HomeOrAway == 'HOME'
                    ? { color: 'black' }
                    : { color: 'black' },
                ]"
              >
                {{ item.Opponent }}
              </span>
            </p>
          </template>
          <!-- matchup ends -->

          <!-- Fp -->
          <template v-slot:item.FPPDdraftking="{ item }">
            <p class="caption" v-if="slates[0].Operator == 'DraftKings'">
              ${{ item.FPPDdraftking >> 0 }}
            </p>
            <p v-else class="caption">${{ item.FPPDfanduel >> 0 }}</p>
          </template>
          <!-- Fp ends -->

          <!-- FPPG -->
          <template v-slot:item.FPPG="{ item }">
            <p class="caption">{{ item.FPPG >> 0 }}</p>
          </template>
          <!-- FPPG ends -->

          <!-- projection -->
          <template v-slot:item.DraftKingsProjection="{ item }">
            <p v-if="slates[0].Operator == 'DraftKings'" class="caption">
              {{ item.DraftKingsProjection.toFixed(1) }}
            </p>
            <p v-else class="caption">
              {{ item.FandDualProjection.toFixed(1) }}
            </p>
          </template>
          <!-- projection ends -->
        </v-data-table>
      </div>
    </v-sheet>
  </div>
</template>

<script>
//   import { mapGetters, mapState } from 'vuex';
export default {
  name: "SaveTopPlaysTable",
  props: {
    playerDetails: {
      type: [Array, Object],
      default: () => {},
    },
    selection: {
      type: String,
      default: () => "",
    },
    selectionDS: {
      type: String,
      default: () => "",
    },
    selectionF: {
      type: String,
      default: () => "",
    },
    selectionFS: {
      type: String,
      default: () => "",
    },
    slates: {
      type: Array,
      default: () => [],
    },
    slateID: {
      type: String,
      default: "",
    },
    defaultSport: {
      type: String,
      default: "",
    },
    defaultOptimizer: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      footerProps: { "items-per-page-options": [15, 30, 50, -1] },
      headers: [
        {
          text: "Profile",
          value: "PhotoUrl",
          sortable: false,
          align: "start",
        },
        {
          text: "Player",
          value: "Name",
          sortable: false,
          align: "center",
          width: "50px",
        },
        { text: "Team", value: "Team", align: "start" },
        {
          text: "Position",
          value: "DraftKingsPosition",
          align: "start",
        },
        // { text: "DepthChart", value: "DepthChartOrder", align: "start" },
        // { text: 'Salary($)', value: 'DraftKingsSalary', align: 'start' },
        {
          text: "Match",
          value: "Opponent",
          sortable: false,
          align: "start",
        },
        //   { text: '', value: 'OpponentRank', align: 'start' },
        {
          text: "FP",
          value: "FPPDdraftking",
          align: "start",
          width: "30px",
        },
        // { text: "Val", value: "FanDualVal" },
        { text: "FPPG", value: "FPPG", align: "start", width: "30px" },
        {
          text: "Proj.",
          value: "DraftKingsProjection",
          align: "start",
          width: "30px",
        },
        //   {
        //     text: 'Min%',
        //     value: 'min',
        //     sortable: false,
        //     align: 'start',
        //     width: '80px',
        //   },
        //   {
        //     text: 'Max%',
        //     value: 'max',
        //     sortable: false,
        //     align: 'start',
        //     width: '80px',
        //   },
        //   {
        //     text: '',
        //     value: 'type',
        //     align: 'start',
        //     width: '110px',
        //     sort: (a, b) => {
        //       if (a > b) {
        //         // //console.log("a", a);
        //         return 1;
        //       }
        //       if (a < b) {
        //         // //console.log("b", b);
        //         return -1;
        //       }
        //       return 0;
        //     },
        //   },
      ],
    };
  },
};
</script>

<style scoped></style>
